'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { getSuspensionStatus } from '../api/suspensionStatus';
import reviewState from '../constants/reviewState';
import { Button } from 'foundations-components/transitional/components/Button';
import InformationModal from './InformationModal';
import getEventKey from '../utils/getEventKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DetailsContentModBanner = ({
  contentId,
  keyWord,
  status,
  slaCopyType,
  usageTracker,
  flush = false
}) => {
  const [newStatus, setStatus] = useState(status);
  const [open, setOpen] = useState(false);
  const [newSlaCopyType, setSlaCopyType] = useState(slaCopyType);
  useEffect(() => {
    let cancel = false;
    if (!status && contentId) {
      getSuspensionStatus(contentId, keyWord).then(data => {
        if (cancel) return;
        const contentData = Object.assign({}, data, {
          contentType: keyWord
        });
        setStatus(contentData.reviewState);
        setSlaCopyType(contentData.slaCopyType);
      }).catch(() => setStatus(null));
    } else {
      setStatus(status);
      setSlaCopyType(slaCopyType);
    }
    return () => {
      cancel = true;
    };
  }, [contentId, keyWord, status, slaCopyType]);
  const determineBannerType = () => {
    if (newStatus === reviewState.BLOCKED) return 'danger';
    if (newStatus === reviewState.IN_REVIEW) return 'warning';
    return null;
  };
  const bannerType = determineBannerType();
  const showBanner = !!bannerType;
  useEffect(() => {
    if (showBanner && usageTracker) {
      usageTracker.track(getEventKey(keyWord), {
        action: 'details-banner-loaded'
      });
    }
  }, [showBanner]); // eslint-disable-line

  const handleClick = () => {
    if (usageTracker) {
      usageTracker.track(getEventKey(keyWord), {
        action: 'open-close-modal-click'
      });
    }
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [open && /*#__PURE__*/_jsx(InformationModal, {
      toggleModal: handleClick,
      status: newStatus,
      contentType: keyWord,
      slaCopyType: newSlaCopyType,
      usageTracker: usageTracker
    }), showBanner && /*#__PURE__*/_jsxs(Alert, {
      "data-test-id": "details-mod-banner",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `contentLabel.${newStatus}.detailBanner.${keyWord}.title`
      }),
      type: bannerType,
      marginBlockStart: flush ? undefined : '400',
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `contentLabel.${newStatus}.detailBanner.${keyWord}.description`
      }), /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: handleClick,
        "data-test-id": "details-banner-button",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `contentLabel.${newStatus}.detailBanner.${keyWord}.button`
        })
      })]
    })]
  });
};
DetailsContentModBanner.propTypes = {
  status: PropTypes.string,
  slaCopyType: PropTypes.string,
  keyWord: PropTypes.string.isRequired,
  contentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  usageTracker: PropTypes.object
};
export default DetailsContentModBanner;